<script setup>

import { inject, ref, computed, watch } from 'vue';
import TieredMenu from 'primevue/tieredmenu';

import ModaleEditionUtilisateur from './ModaleEditionUtilisateur.vue';

const { utilisateur, libellePage } = defineProps({
    utilisateur: Object,
    libellePage: String
});

const modifierUtilisateur = inject('modifierUtilisateur');

const menu = ref(null);
const affichageModaleEditionUtilisateur = ref(false);

const descUtilisateur = computed(() => {
    if (utilisateur && !utilisateur.inconnu) {
        if (utilisateur.prenom) {
            return `${utilisateur.prenom.substring(0, 1).toUpperCase()}. ${utilisateur.nomFamille.toUpperCase()}`;
        } else {
            return utilisateur.nom.toUpperCase();
        }
    } else {
        return '?';
    }
});

watch(() => utilisateur?.inconnu, (inconnu) => {
    affichageModaleEditionUtilisateur.value = inconnu;
});

watch(() => utilisateur?.estModifie, (estModifie) => {
    if (estModifie) {
        delete utilisateur.estModifie;
        affichageModaleEditionUtilisateur.value = false;
    }
});

const itemsMenu = [
    {
        label: 'Modifier mes informations',
        icon: 'fa fa-user',
        command: () => {
            affichageModaleEditionUtilisateur.value = true;
        }
    }/*,
    {
        label: 'Me déconnecter',
        icon: 'fa fa-sign-out',
        command: () => {
            affichageModaleEditionUtilisateur.value = true;
        }
    }*/
];

function basculerAffichageMenu(event) {
	menu.value.toggle(event);
}

</script>

<template>
	<div class="bandeau">
        <div class="infos-produit">
            <img alt="Vue logo" class="logo" src="@/assets/logo.png" width="28" height="28" />
            <label class="nom-produit">Modalink</label>
        </div>
        <div class="libelle-modele">
            <label>{{ libellePage }}</label>
        </div>
        <div class="infos-utilisateur">
            <i class="fa-solid fa-user icone"/>
            <label>{{ descUtilisateur }}</label>
            <button class="bouton btn-menu fa-solid fa-caret-down" @click="basculerAffichageMenu" />
            <TieredMenu 
		      ref="menu" 
			  :model="itemsMenu" 
			  :popup="true" />
        </div>
		<ModaleEditionUtilisateur 
            v-if="utilisateur"
			v-model:visible="affichageModaleEditionUtilisateur" 
			:utilisateur="utilisateur"
			@enregistrer="(utilisateurModifie) => modifierUtilisateur(utilisateurModifie)" />
	</div>
</template>

<style scoped>

.bandeau {
    position: sticky;
    top: 0px;
    display: flex;
    align-items: center;
	width: 100%;
    height: 8vh;
    z-index: 3;
    flex-direction: row;
    background-color: var(--couleur-primaire);
    padding: 10px;
    border-bottom: 1px solid var(--couleur-bordure);
}

.infos-produit {
    display: flex;
    font-size: 16px;
    font-weight: bold !important;
    padding: 0px 20px 0px 10px;
    flex-grow: 0;
    min-height: 5vh;
    align-items: center;
    background-color: white;
    border: 1px solid var(--couleur-primaire);
    border-radius: 6px;
    margin-left: 5px; 
}

.logo {
    margin: 0 1rem 0 1rem;
}

.libelle-modele {
    display: flex;
    font-size: 22px;
    font-weight: bold !important;
    color: white;
    padding: 0px 30px;
    flex-grow: 1;
    min-height: 5vh;
    align-items: center;
}

.infos-utilisateur {
    color: white;
    font-size: 14px;
}

.icone {
    margin-left: 10px; 
    margin-right: 10px; 
}

.btn-menu {
    margin-left: 5px;
    color: white;
    background-color: var(--couleur-primaire);
    border-color: var(--couleur-primaire);
}

</style>